// 新增实体频道名
export const newEntityType = ['超值馈', '天猫优购', '唯品会', '福鲜生', '吉拉福'];

export const allEntityType = ['优选生活', '蛋糕', '节日礼包', '图书', '京东优选', '小米有品', '网易严选', '东福超市', '健康商城', '天猫优购', '唯品会', '福鲜生', '超值馈', '吉拉福'];

// 新增实体频道code/path
export const newEntityPath = ['feedBack', 'tmall', 'wphVip', 'fresh', 'mart', 'jiraffe'];

export const newEntityInfo = {
  feedBack: '超值馈',
  tmall: '天猫优购',
  wphVip: '唯品会',
  fresh: '福鲜生',
  jiraffe: '吉拉福',
};

// 实体频道path
export const entityPath = ['life', 'cake', 'spree', 'book', 'jdyx', 'xmyp', 'wyyx', 'chaoshi', 'healthy', 'tmall', 'wphVip', 'fresh', 'feedBack', 'jiraffe'];

// 体检性别
export const genders = {
  single: '女未婚',
  man: '男性',
  married: '女已婚',
};

// 前台标签
export const frontTagType = {
  ADVANCESALE: 1000000001,
  CHANNEL: 9005,
  TIJIANZIYING: 9007,
  XIANGOU: 9003,
  QIGOU: 9004,
  COUPONREDUCE: 400001,
  REDUCE: 2001,
  CHOUJIANG: 300001,
  QIBU: 1001,
  QIANGGOU: 1004,
  XINPIN: 9001,
  LEXIANG: 8000001,
  IMAGE: 8000003,
  FRONTTAG: 9006,
  PRIZEGOODS: 8000005,
  CARTLOTTERY: 8000006,
};

// 默认优先展示图片的前台标签
export const priorityList = [9006];

// 商品标题展示的前台标签
export const titleTags = [9005, 9006];

export const channelPath = {
  //
};

// /df_df
// 新增退登code：AUTH001999
export const LOGOUT_CODE = 'AUTH001999'
// 四级地址成功code
export const SUCCESS_CODE = 'BFF000000'